// NGRX

// OLCI
import { BoardingPassResponse, BoardingPassPayload } from '../models';
import { OlciActionTypes } from '../actions/olci';
import { constants } from '../constants/constants';
import * as _ from 'lodash';
export interface State {
	loaded: false;
	loading: false;
	setsailpass: BoardingPassPayload | any;
	error: any;
	boardingPassErrors: string[];
}

export const initialState: State = {
	loaded: false,
	loading: false,
	setsailpass: null,
	error: null,
	boardingPassErrors: []
};

export function reducer(state: State = initialState , action: any): State {
	switch (action.type) {
		case OlciActionTypes.GET_SET_SAIL_PASS:
			return Object.assign({}, state, {
				loading: true,
				loaded: false
			});

		case OlciActionTypes.GET_SET_SAIL_PASS_SUCCESS: {
      const ssp = action.payload as BoardingPassResponse;

			if (ssp.status !== constants.HTTP_STATUS_CODE.SUCCESS) {
				let error: any = _.get(ssp, 'error', null);
				if (ssp.errors) {
					error = ssp.errors;
				}
				return Object.assign({}, state, { loading: false, error: error });
			}

			const boardingPass = _.get(ssp, 'payload.reservations[0].boardingPasses[0]', null);
      const { validations, warnings } = ssp.payload;
      const notOutstandingBalance = (error: any) => error.validationErrors.every((errorMsg: string) => errorMsg !== constants.BOARDING_PASS_OUTSTANDING_BALANCE_ERROR)
			if (ssp.status === constants.HTTP_STATUS_CODE.SUCCESS && (validations.length && validations.every(notOutstandingBalance)) || warnings.length && !boardingPass) {
				return Object.assign({}, state,
					{
						loaded: true,
						loading: false,
						boardingPassErrors: [constants.HTTP_STATUS_CODE.BACKEND_ERROR]
					});
			} else {
				return Object.assign({}, state, {
					loaded: true,
					loading: false,
					setsailpass: ssp.payload,
					boardingPassErrors: ssp.errors
				});
			}
    }
		default:
			return state;
	}
}

export const getLoaded = (state: State) => state.loaded;
export const getLoading = (state: State) => state.loading;
export const getSetSailPass = (state: State) => state.setsailpass;
